var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "8px",
    height: "8px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(166, 166, 166)",
    d: "M7.251,1.660 L4.653,4.265 L7.251,6.871 C7.471,7.091 7.471,7.447 7.251,7.667 C7.142,7.778 6.998,7.832 6.854,7.832 C6.710,7.832 6.567,7.777 6.457,7.667 L3.859,5.062 L1.261,7.667 C1.151,7.778 1.008,7.832 0.864,7.832 C0.720,7.832 0.577,7.777 0.467,7.667 C0.248,7.447 0.248,7.091 0.467,6.871 L3.065,4.265 L0.467,1.660 C0.248,1.440 0.248,1.083 0.467,0.863 C0.686,0.643 1.042,0.643 1.261,0.863 L3.859,3.469 L6.457,0.863 C6.677,0.643 7.032,0.643 7.251,0.863 C7.471,1.083 7.471,1.439 7.251,1.660 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo);
export default __webpack_public_path__ + "static/media/no.ff0a38bbf3ee5ac2fcaccae741b15109.svg";
export { ForwardRef as ReactComponent };